module.exports = {
	name: 'default', // 渠道名
	premiumMessage: '',
	shopName: '票牛网签约商家',
	noLoginPhonePlaceholder: '',
	orderConfirmRuleCheck: '已阅读并同意',
	orderBottomText: '',
	loginExtraHintText: '',
	orderListApi: null,
	hideCoupon: false, // 是否隐藏优惠券入口
  hideGiftCard: false, //是否隐藏礼品卡
	needNav: false, // 是否展示导航条
	noAppLink: true, // 是否隐藏下载链接
	kefuType: 2, // 1: 环信 2: 电话
	kefuText: '票牛客服',
	isListHome: true, // 是否以列表页作为首页
	stripBrand: true, // 是否去除品牌相关信息（包括页面标题和下载引导）
	showUserEntry: true, // 列表页面我的入口）
	userEntryType: 1, //1：默认 2：列表页搜索栏顶部
	supportZeroPay: false,
	hideReview: false,
	hideBuyNum: false,
	hideCredit: false,
	isFromThird: true, //三方渠道
	hideSeekTicket: true, //隐藏求票入口
  isHideTravel: false, // 是否隐藏旅游玩乐项目
  isHideLife: true,  //是否隐藏潮生活
  isNeedLogin: false,   // 是否需要在首页就进行登录
  hideRelatedActivity: false,  // 演出详情页是否显示相关演出
	match() {
		return false // 是否匹配某一渠道
	},
	login: null, // 渠道特殊的登录方法
	pay: null, // 渠道特殊的支付方式
	moreOrder: null // 渠道自由查看更多订单逻辑
}



// WEBPACK FOOTER //
// ./src/mods/channels/default.js